/** Foundation · Timesheet — colonna "Controllo": un segnale discreto, i dettagli al passaggio del mouse. */
import React from "react";
import { Moon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { formatDuration } from "@/foundation/duration";

const dur = (m, fmt) => formatDuration((m || 0) / 60, fmt);

export function DayCheckCell({ date, ev, theo, fmt }) {
  const issues = ev?.issues || [];
  const filled = !!(ev?.workedMinutes || ev?.justifiedMinutes);
  const level = issues.some((i) => i.level === "error") ? "error" : issues.some((i) => i.level === "warning") ? "warning" : issues.length ? "info" : filled ? "ok" : "none";
  const diff = filled ? ev?.differenceMinutes : null;
  const dot = { error: "bg-suite-error", warning: "bg-amber-500", info: "bg-sky-500", ok: "bg-emerald-500", none: "bg-transparent" }[level];
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="relative inline-flex min-w-[70px] items-center gap-1.5 text-[11px]" data-testid={`ts-${date}-issues`} data-level={level}>
          <span className={`h-2 w-2 shrink-0 rounded-full ${dot}`} />
          {ev?.night && <Moon size={11} className="text-sky-600" aria-label="Turno notturno" />}
          <span className={`font-mono ${diff > 0 ? "text-emerald-700" : diff < 0 ? "text-suite-error" : "text-suite-neutral-400"}`} data-testid={`ts-${date}-diff`}>
            {diff ? formatDuration(diff / 60, fmt, { signed: true }) : ""}
          </span>
          <span className="sr-only" data-testid={`ts-${date}-theoretical`}>{theo ? dur(theo, fmt) : ""}</span>
          <span className="sr-only" data-testid={`ts-${date}-pause`}>{ev?.pauseMinutes ? dur(ev.pauseMinutes, fmt) : ""}</span>
        </span>
      </TooltipTrigger>
      <TooltipContent side="left" className="text-xs">
        <div className="grid grid-cols-[auto_auto] gap-x-3 font-mono">
          <span className="font-sans text-suite-neutral-400">Teoriche</span><span>{theo === null ? "—" : dur(theo, fmt)}</span>
          <span className="font-sans text-suite-neutral-400">Pausa</span><span>{dur(ev?.pauseMinutes, fmt)}</span>
          <span className="font-sans text-suite-neutral-400">Differenza</span><span>{diff ? formatDuration(diff / 60, fmt, { signed: true }) : "—"}</span>
        </div>
        {!!issues.length && <ul className="mt-1.5 space-y-0.5 border-t pt-1.5">{issues.map((i, k) => <li key={k}>• {i.message}</li>)}</ul>}
      </TooltipContent>
    </Tooltip>
  );
}

export default DayCheckCell;
